<!--
利用状況画面
URL：/usage
-->

<template>
  <div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <div v-if="this.tableCategory === 'CATEGORY_GROUP' || this.tableCategory === 'CATEGORY_LOGIN'">
    <list-table class="mt-12"
      :usageTitle="usageTitle"
      :headerText="headerText"
      :itemList="itemList"
      @on-change-type="onChangeType"
      @on-click-group="onClickGroup"
      @on-input-year="onInputYear"
      @on-click-back="onClickBack">
    </list-table>
    </div>
    <div v-if="this.tableCategory === 'CATEGORY_PERSONAL' || this.tableCategory === 'CATEGORY_PERSONAL_LOGIN'">
    <list-table-personal class="mt-12"
      :usageTitle="usageTitle"
      :headerText="headerText"
      :itemList="itemList"
      @on-change-type="onChangeType"
      @on-click-group="onClickGroup"
      @on-input-year="onInputYear"
      @on-click-back="onClickBack">
    </list-table-personal>
    </div>
  </div>
</template>

<script>
import ListTable from "../../components/usage-situation/list-table.vue";
import ListTablePersonal from "../../components/usage-situation/list-table-personal.vue";
import Api from "@/logic/api/api.js";
import Alert from "../../components/common/alert.vue";
import AlertBuilder from "../../logic/common/alert-contents";
import valueMapper from "../../logic/common/value-mapper";
export default {
  components: {
    "list-table": ListTable,
    "list-table-personal": ListTablePersonal,
    alert: Alert,
  },
  computed: {
    itemList() {
      return this.$store.getters.manageUsageList;
    },
  },
  mounted() {
    this.reloadData();
  },
  data() {

    /**
     * テーブル種別
     *   CATEGORY_GROUP:    漁協別利用状況  漁協別月別利用者数（アクティブユーザー数）を生産記録人数で表示する
     *   CATEGORY_LOGIN:    漁協別利用状況  漁協別月別利用者数（アクティブユーザー数）をログイン人数で表示する
     *   CATEGORY_PERSONAL: 個人別入力件数  選択した漁協の個人別生産記録入力回数（水揚げ・出荷の合計）を表示する
     *   CATEGORY_PERSONAL_LOGIN:    個人別利用状況  選択した漁協の個人別利用者（アクティブユーザー）を月毎にアクセス履歴を表示する
     */
    this.tableCategory = "CATEGORY_GROUP";

    // タイトル
    this.usageTitle = "漁協別 利用状況（アクティブユーザー数）";

    // 表示月オフセット
    //（0:1月始まり 9:10月始まり）
    this.disp_offset = 0;

    // ヘッダー文言
    this.headerText = [];
    this.createHeaderText();

    // 個人別件数表示用グループID
    this.selectGid = "";

    // API結果格納
    this.summaryData = [];

    // 利用状況一覧リストをクリア
    this.resetUsageList();

    // 表示年リスト
    this.selectDispYears = [];

    // 表示年リスト作成(現在からシステム基準年(2021年)までの西暦と和暦を詰める)
    var today = new Date();
    var nowYear = today.getFullYear();
    // 対象年度取得
    for (var i = 0; i <= nowYear - 2021; i++) {
      var nowYearJP = "(令和" + (nowYear - i - 2018) + ")";
      this.selectDispYears[i] = nowYear - i + nowYearJP + "年";
    }

    // 表示年
    this.dispYear = this.selectDispYears[0];

    return {
      errors: [],
      tableCategory: this.tableCategory,
      productNum: this.productNum,
    };
  },
  methods: {
    /**
     * 表示年が選択されたらデータ再取得
     */
    onInputYear(year) {
      this.dispYear = year;

      this.reloadData();
    },
    /**
     * ヘッダー表示用配列生成
     */
    createHeaderText() {

      if (this.tableCategory === 'CATEGORY_PERSONAL_LOGIN') {
        this.headerText = ["漁協", "ユーザー名"];
      } else if (this.tableCategory === 'CATEGORY_PERSONAL') {
        this.headerText = ["漁協", "生産者名"];
      } else {
        this.headerText = ["漁協", "所属人数"];
      }
      let month = ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];

      // オフセットに合わせて表示月の並びを変える
      let month_idx = this.disp_offset;

      for (let i = 0; i < 12; i++) {
        if (month_idx > 11) {
          month_idx = 0;
        }
        this.headerText.push(month[month_idx]);
        month_idx++;
      }
    },
    /**
     * 集計結果取得
     */
    reloadData() {

      let postData = this.getPostData();
      this.$store.commit("setWaiting", true);
      Api.call("/admin/usage", postData)
        .then((result) => {
          this.$store.commit("setWaiting", false);

          this.summaryData = result.summaryData;

          //APIから取得した結果を画面に表示する
          if (this.tableCategory === 'CATEGORY_GROUP') {
            this.$store.commit("setManageUsageList", this.getGroupList());
          } else if (this.tableCategory === 'CATEGORY_LOGIN') {
            this.$store.commit("setManageUsageList", this.getLoginList());
          } else if (this.tableCategory === 'CATEGORY_PERSONAL') {
            this.$store.commit("setManageUsageList", this.getPersonalList(this.selectGid));
          } else if (this.tableCategory === 'CATEGORY_PERSONAL_LOGIN') {
            this.$store.commit("setManageUsageList", this.getPersonalLoginList(this.selectGid));
          }
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              400: AlertBuilder.error("取得に失敗しました"),
              401: AlertBuilder.invalid(),
              403: AlertBuilder.error("権限がありません"),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    /**
     * 生産集計情報を取得する
     */
    getPostData() {
      // 表示年をリクエスト
      return {
        summary_year: this.dispYear.slice(0, 4),
      };
    },
    /**
     * グループ別生産者数を設定
     * [グループ名,生産者数,生産情報入力人数1,生産情報入力人数2,...,生産情報入力人数12]
     */
    getGroupList() {
      return this.summaryData.map((group) => {
        return {
          groupId: group.group_id,
          groupName: group.group_name,
          producerNumOrName: group.producer_num,
          productNum: group.haccp_total.slice(this.disp_offset, this.disp_offset+13),
        };
      })
    },
    /**
     * グループ別ログイン者数を設定
     * [グループ名,生産者数,ログイン人数1,ログイン人数2,...,ログイン人数12]
     */
    getLoginList() {
      return this.summaryData.map((group) => {
        return {
          groupId: group.group_id,
          groupName: group.group_name,
          producerNumOrName: group.all_users_num,
          productNum: group.login_total.slice(this.disp_offset, this.disp_offset+13),
        };
      })
    },
    /**
     * 個人別生産情報入力件数を設定
     * [グループ名,生産者名,入力件数1,入力件数2,...,入力件数12]
     */
    getPersonalList(gid = "") {
      const groupData = this.summaryData.find((item) => { return item.group_id === gid});
      return groupData["producer_list"].map((producer) => {
        return {
          groupId: groupData["group_id"],
          groupName: groupData["group_name"],
          producerNumOrName: producer["name"],
          productNum: producer["count"],
        }
      });
    },
    /**
     * 個人別生産情報入力件数を設定
     * [グループ名,生産者名,アクセス状況1,アクセス状況2,...,アクセス状況12]
     */
    getPersonalLoginList(gid = "") {
      const groupData = this.summaryData.find((item) => { return item.group_id === gid});
      return groupData["all_users_list"].map((loginUsers) => {
        return {
          groupId: groupData["group_id"],
          groupName: groupData["group_name"],
          producerNumOrName: loginUsers["name"],
          productNum: loginUsers["count"],
        }
      });
    },
    /**
     * 生産記録入力者数・ログイン数の切り替え
     */
    onChangeType(selectedType) {
      this.usageTitle = "漁協別 利用状況（アクティブユーザー数）";

      // ヘッダー情報を更新
      this.createHeaderText();

      // 利用状況一覧リストをクリア
      this.resetUsageList();

      // キャッシュ更新処理
      if (selectedType == 1) {
        this.tableCategory = "CATEGORY_GROUP";
        this.$store.commit("setManageUsageList", this.getGroupList());
      } else if (selectedType == 2) {
        this.tableCategory = "CATEGORY_LOGIN";
        this.$store.commit("setManageUsageList", this.getLoginList());
      }
    },
    /**
     * グループ名がクリックされた
     */
    onClickGroup(gid) {
      if (this.tableCategory === 'CATEGORY_GROUP') {
        // グループIDを保持
        this.selectGid = gid;

        this.tableCategory = "CATEGORY_PERSONAL";
        this.usageTitle = "漁協別（個人別）入力件数";

        // ヘッダー情報を更新
        this.createHeaderText();

        // 利用状況一覧リストをクリア
        this.resetUsageList();

        // キャッシュ更新処理
        this.$store.commit("setManageUsageList", this.getPersonalList(gid));
      } else if (this.tableCategory === 'CATEGORY_LOGIN'){
          // グループIDを保持
        this.selectGid = gid;

      this.tableCategory = "CATEGORY_PERSONAL_LOGIN";
      this.usageTitle = "漁協別（個人別）ログイン状況";

      // ヘッダー情報を更新
      this.createHeaderText();

      // 利用状況一覧リストをクリア
      this.resetUsageList();

      // キャッシュ更新処理
      this.$store.commit("setManageUsageList", this.getPersonalLoginList(gid));

      }
    },
    /**
     * 一覧へボタンがクリックされた
     */
    onClickBack() {
      this.usageTitle = "漁協別 利用状況（アクティブユーザー数）";
      this.tableCategory = "CATEGORY_GROUP";

      // ヘッダー情報を更新
      this.createHeaderText();
      // 利用状況一覧リストをクリア
      this.resetUsageList();

      // キャッシュ更新処理
      this.$store.commit("setManageUsageList", this.getGroupList());
    },
    /**
     * メッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
    /**
     * 利用状況一覧を初期化する
     */
    resetUsageList() {
      let resetUsageList = [];
      this.$store.commit("setManageUsageList", resetUsageList);
    },
  },
};
</script>

<style></style>
